<template>
  <div :class="{'disabled': !enabled}" class="le-select-menu" @click="onActionMenuClick" ref="button">
    <i class="ico-5 ico-three-dots"></i>
  </div>
</template>

<script>

  export default {
    name: 'le-select-menu',
    components: {
    },
    props: {
      isListOpen: {
        type: Boolean,
        required: true,
      },
      enabled: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      onActionMenuClick() {
        this.toggleActionMenu(!this.isListOpen);
      },
      toggleActionMenu(newState) {
        if (this.enabled) {
          this.$emit('toggle', newState);
        }
      },
    },
  };
</script>

<style lang="scss">
  .le-select-menu {
    width: 18px;
    .ico-three-dots {
      height: 7px;
      width: 18px;
      cursor: pointer;
      @include themify {
        color: getColor('text');
      }
    }
    &.disabled {
      .ico-three-dots {
        cursor: default;
        @include themify {
          color: getColor('disabled');
        }
      }
    }
  }

</style>
